const initProductMediaSwipers = (root = document) => {
  root.querySelectorAll('.product-swiper').forEach((swiperEl) => {
    if (swiperEl.swiper) return;

    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    const viewer = swiperEl.closest('[id^="GalleryViewer"]');
    const buttons = viewer ? viewer.querySelector('.slider-buttons') : null;

    if (!wrapper || wrapper.children.length <= 1) {
      if (buttons) buttons.remove();
      return;
    }

    const mediaGallery = swiperEl.closest('media-gallery');
    const sectionId = mediaGallery ? mediaGallery.id.replace('MediaGallery-', '') : null;
    const priceMapScript = sectionId
      ? document.querySelector(`script[data-variant-price-map="${sectionId}"]`)
      : null;
    const priceContainer = sectionId ? document.getElementById(`price-${sectionId}`) : null;

    let variantPriceMap = null;
    if (priceMapScript && priceContainer) {
      try {
        variantPriceMap = JSON.parse(priceMapScript.textContent);
      } catch (error) {
        console.error(error);
      }
    }

    // Extra images of a sofa variant point to their variant image, so they keep that variant's price/tabs/description
    const getVariantMediaId = (slideEl) => slideEl?.dataset.variantMediaId || slideEl?.dataset.mediaId;

    const updatePriceForSlide = (slideEl) => {
      if (!variantPriceMap || !slideEl) return;
      const mediaId = getVariantMediaId(slideEl);
      const priceHtml = mediaId ? variantPriceMap[mediaId] : null;
      if (priceHtml) priceContainer.innerHTML = priceHtml;
    };

    const tabMaps = sectionId
      ? Array.from(document.querySelectorAll(`script[data-variant-tab-map="${sectionId}"]`)).flatMap((script) => {
          try {
            return [{ accordion: script.closest('[data-accordion-block]'), map: JSON.parse(script.textContent) }];
          } catch (error) {
            console.error(error);
            return [];
          }
        })
      : [];

    const updateTabsForSlide = (slideEl) => {
      const mediaId = getVariantMediaId(slideEl);
      if (!mediaId) return;
      tabMaps.forEach(({ accordion, map }) => {
        const content = accordion?.querySelector('.accordion__content');
        if (!content || !(mediaId in map)) return;
        content.innerHTML = map[mediaId];
        accordion.classList.toggle('hidden', map[mediaId] === '');
      });
    };

    const descriptionMapScript = sectionId
      ? document.querySelector(`script[data-variant-description-map="${sectionId}"]`)
      : null;
    const descriptionContainer = sectionId ? document.getElementById(`Description-${sectionId}`) : null;

    let variantDescriptionMap = null;
    if (descriptionMapScript && descriptionContainer) {
      try {
        variantDescriptionMap = JSON.parse(descriptionMapScript.textContent);
      } catch (error) {
        console.error(error);
      }
    }

    const updateDescriptionForSlide = (slideEl) => {
      const mediaId = getVariantMediaId(slideEl);
      if (!variantDescriptionMap || !mediaId || !(mediaId in variantDescriptionMap)) return;
      descriptionContainer.innerHTML = variantDescriptionMap[mediaId];
      descriptionContainer.classList.toggle('hidden', variantDescriptionMap[mediaId] === '');
    };

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      a11y: true,
      keyboard: { enabled: true },
      noSwipingClass: 'swiper-no-swiping',
      navigation: {
        prevEl: buttons ? buttons.querySelector('[data-swiper-prev]') : null,
        nextEl: buttons ? buttons.querySelector('[data-swiper-next]') : null,
      },
      on: {
        slideChange(instance) {
          const counter = buttons ? buttons.querySelector('.slider-counter--current') : null;
          if (counter) counter.textContent = instance.realIndex + 1;
          updatePriceForSlide(instance.slides[instance.activeIndex]);
          updateTabsForSlide(instance.slides[instance.activeIndex]);
          updateDescriptionForSlide(instance.slides[instance.activeIndex]);
        },
      },
    });

    const syncActiveSlide = () => {
      const activeSlide = wrapper.querySelector('.is-active');
      if (!activeSlide) return;
      const index = Array.prototype.indexOf.call(wrapper.children, activeSlide);
      if (index > -1 && index !== swiper.activeIndex) swiper.slideTo(index, 0);
    };

    new MutationObserver(syncActiveSlide).observe(wrapper, {
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  });
};

initProductMediaSwipers();

// The theme editor re-renders sections without re-running their scripts, so set up the new gallery again
document.addEventListener('shopify:section:load', (event) => initProductMediaSwipers(event.target));
